/**
 * @fileoverview Agent definition for character-image-prompt-creator-v2.
 *
 * This agent takes character details and creates a rich, artistic prompt
 * for an image generation model, focusing on physical description and clothing.
 *
 * @category visuals.prompts.characters
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'character-image-prompt-creator-v2',
  kind: 'primitive',
  name: 'Character Image Prompt Creator',
  description: 'Takes character details and creates a rich, artistic prompt for an image generation model.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.prompts.characters',
    usedBy: [
      'use-character-image-generation-v2.ts',
      'use-character-image-generation-fal-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'portrait-prompt-creator-v2',
      'character-image-creator-v2',
      'character-image-creator-fal-v2',
    ],
  },
};
